<template>
    <div class="authorization-input_label">
        <div class="prime-password_label">
            <PrimePassword 
                :data-has-value="!!modelValue" 
                :data-has-placeholder="!placeholderHidden && !modelValue" 
                :data-focused="placeholderHidden" 
                :id="$attrs?.id ?? 'password'"
                toggleMask 
                :feedback="false" 
                v-model="modelValue"
                @focus="togglePlaceholder"  
                @blur="togglePlaceholder"  
                :placeholder="!placeholderHidden ? ($attrs?.placeholder ?? 'Password') : ''" 
                aria-label="Password" 
                :inputId="`${$attrs?.id ?? 'password'}-input`"
                :class="{
                    'authorization-password_input': true,
                    'invalid-state-password': passwordErrors != null
                }"
                :pt="{
                    pcInputText: {
                        root: {
                            autocomplete: 'off'
                        }
                    }
                }"
            />
            <label :for="`${$attrs?.id ?? 'password'}-input`">
                <p>{{ $attrs?.placeholder ?? 'Password' }}</p>
            </label>
        </div>
        <div class="input-folder">
            <ul class="input-errors" v-if="passwordErrors?.length > 1">
                <li v-for="(passwordError, key) in passwordErrors" class="input-support-text invalid-state" :key="key">
                    {{ passwordError }}
                </li>
            </ul>
            <p class="input-support-text invalid-state" v-else-if="passwordErrors?.length == 1">
                {{ passwordErrors[0] }}
            </p>
        </div>   
    </div>
</template>
<script setup lang="ts">
    import { ref, computed } from "vue";

    let modelValue = defineModel();
    const props = defineProps({
        errors: {
            type: [String,Array],
            default: null
        }
    })
    
    const passwordErrors = computed(()=>{
        if(Array.isArray(props.errors)){
            return props.errors.length > 0 ? [...props.errors] : null;
        }else{
            return props.errors ? [props.errors] : null;
        }
    })

    const placeholderHidden = ref(false);
    const togglePlaceholder = ()=>{placeholderHidden.value = !placeholderHidden.value};
</script>